import Vue from "vue";
import axios from "axios";
import { Qualify } from "@/columns";
import ActivityFlowDialogLocker from "@/components/activity_flow/ActivityFlowDialogLocker.vue";

const vue = new Vue();

export const QuealifyGetTableData = async function (thisSales) {
  //console.log("penddingPaymentgetTableData");
  //const axiosSource = axios.CancelToken.source();
  var request = null;
  if (request) cancel();
  const axiosSource = axios.CancelToken.source();
  request = { cancel: axiosSource.cancel, msg: "Loading..." };

  let tableData = [];

  const Parameters = {
    params: {
      CompanyCode: thisSales.currentCompany,
      SellerCode: thisSales.currentUser.PersonCode,
      CustomerServicesCode: thisSales.currentUser.CustomerServiceExec_, //!= null ? this.currentUser.CustomerServiceExec_ : 0,
      EmployeeId: thisSales.currentUser.EmployeeId,
      UserId: thisSales.currentUser.UserID,
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      optionStr: "sp"
    }
  };

  if (
    //thisSales.currentUser.Roles.some((e) => e.Id === 19 || e.Id === 25)
    thisSales.currentUser.PositionID == 52 ||
    thisSales.currentUser.PositionID == 74 ||
    thisSales.currentUser.PositionID == 16
  ) {
    await vue.$http
      .get("/api/MessageApi/GetExcutiveStatDetails", Parameters)
      .then((response) => {
        tableData = response.data[0].RequestsDto;
      })
      .catch((error) => {
        console.error(error);
      });
    return tableData;
  } else {
    return tableData;
  }
};
const cancel = function () {
  this.request.cancel();
  this.clearOldRequest("Cancelled");
};

export const QuealifyTaksColumns = Qualify;

export const QuealifyPaymentActions = [
  {
    icon: "el-icon-view",
    label: "Ver",
    command: "details_view"
  },
  {
    icon: "el-icon-plus",
    label: "Calificar",
    command: "rate-validation-request-command"
    //condition: row => row.ServiceRequestTypeDescription
  },
  {
    icon: "el-icon-plus",
    label: "Nueva iteracion",
    command: "new_interaction"
    //condition: row => row.ServiceRequestTypeDescription
  }
];

export const QuealifyPaymentActionHandler = async function (action) {
  ActivityFlowDialogLocker.methods.actionHandlerHelper(action);
};
